'use strict';

wbApp.factory('membershipStudentSvc', ['$q', '$resource', 'repositorySvc',
    function ($q, $resource, repositorySvc) {

        var MembershipStudent = $resource('/Api/MembershipStudent/Get/:userId', {}, {
            'query': { method: 'GET', isArray: true },
            'getByUser': { method: 'GET', url: '/Api/MembershipStudent/GetByUser', isArray: true },
            'getValidByUser': { method: 'GET', url: '/Api/MembershipStudent/GetValidByUser', isArray: true },
            'getByMembership': { method: 'GET', url: '/Api/MembershipStudent/GetByMembership', isArray: true },
            'insert': { method: 'POST', url: '/Api/MembershipStudent/Insert' },
            'update': { method: 'POST', url: '/Api/MembershipStudent/Update' },
            'delete': { method: 'POST', url: '/Api/MembershipStudent/Delete' }
        });

        function getAllAsync() {
            return repositorySvc.get(MembershipStudent, {});
        }

        var lasValidByUser;
        var lastUserId;
        var lastNow;
        function GetByUserValidAsync(userId, now, refresh) {

            var normalizedNow = moment(now).startOf('day');

            if (!normalizedNow.isSame(lastNow) || lastUserId != userId || !lasValidByUser || refresh) {
                lastNow = normalizedNow;
                lastUserId = userId;
                lasValidByUser = repositorySvc.customGet('getValidByUser', MembershipStudent, { userId: userId, now: normalizedNow.toDate() });
            }

            return lasValidByUser;
        }

        var byMembershipId;
        var lastMembershipId;
        function GetAllByMembershipAsync(membershipId) {

            if (!byMembershipId || lastMembershipId !== membershipId) {
                byMembershipId = repositorySvc.customGet('getByMembership', MembershipStudent, { membershipId: membershipId });
                lastMembershipId = membershipId;
            }

            return byMembershipId;
        }

        function insert(data, successCallback, errorCallback) {
            repositorySvc.insert(
                MembershipStudent, // $resource
                byMembershipId,    // collection
                data,              // entity
                successCallback,
                errorCallback,
                'membershipStudentID');
        }

        function update(data, successCallback, errorCallback) {
            repositorySvc.update(
                MembershipStudent, // $resource
                byMembershipId,    // collection
                data,              // entity
                successCallback,
                errorCallback,
                'membershipStudentID');
        }

        function remove(data, errorCallback) {
            repositorySvc.remove(
                MembershipStudent, // $resource
                byMembershipId,    // collection
                data,              // entity
                null,              // successCallback
                errorCallback,
                { membershipStudentID: data.membershipStudentID },
                'membershipStudentID');
        }

        return {
            getAllAsync: getAllAsync,
           // GetByUserAsync: GetByUserAsync,
           // GetByStudentAsync: GetByStudentAsync,
            GetByUserValidAsync: GetByUserValidAsync,
            GetAllByMembershipAsync: GetAllByMembershipAsync,
            insert: insert,
            update: update,
            remove: remove,
        }
    }]);